<template>
  <div class="container-fluid mt--7">
    <!-- START DRAWER -->
    <a-drawer
      title=""
      width="550"
      placement="right"
      @close="onClose"
      :visible="drawerVisible"
    >
      <!-- TEMPLATE -->
      <div v-if="formType == 't'">
        <h6 class="heading-small text-muted mb-4">EPAY Template</h6>
        <base-input label="Name">
          <a-input type="text" v-model="epayTemplate.name" />
        </base-input>
        <base-input label="Code">
          <a-input type="text" v-model="epayTemplate.code" />
        </base-input>
        <div
          class="float-right"
          style="position: absolute; bottom: 20px; right: 20px"
        >
          <button class="btn btn-success" @click.prevent="saveTemplate">
            Save
          </button>
          <button class="btn" @click.prevent="onClose">Cancel</button>
        </div>
      </div>
      <!-- CATEGORY -->
      <div v-if="formType == 'c'">
        <h6 class="heading-small text-muted mb-4">EPAY Category</h6>
        <base-input label="EPAY Template">
          <a-input type="text" v-model="epayTemplate.name" disabled />
        </base-input>
        <base-input label="Name">
          <a-input type="text" v-model="epayCategory.name" />
        </base-input>
        <base-input label="Sequence No">
          <a-input type="text" v-model="epayCategory.sequence_id" />
        </base-input>
        <div
          class="float-right"
          style="position: absolute; bottom: 20px; right: 20px"
        >
          <button class="btn btn-success" @click.prevent="saveCategory">
            Save
          </button>
          <button class="btn" @click.prevent="onClose">Cancel</button>
        </div>
      </div>
      <!-- GROUP -->
      <div v-if="formType == 'g'">
        <h6 class="heading-small text-muted mb-4">EPAY Group</h6>
        <base-input label="EPAY Category">
          <a-input type="text" v-model="epayCategory.name" disabled />
        </base-input>
        <base-input label="Name">
          <a-input type="text" v-model="epayGroup.name" />
        </base-input>
        <base-input label="Code">
          <a-input type="text" v-model="epayGroup.code" />
        </base-input>
        <base-input label="Sequence No">
          <a-input type="text" v-model="epayGroup.sequence_id" />
        </base-input>
        <div
          class="float-right"
          style="position: absolute; bottom: 20px; right: 20px"
        >
          <button class="btn btn-success" @click.prevent="saveGroup">
            Save
          </button>
          <button class="btn" @click.prevent="onClose">Cancel</button>
        </div>
      </div>
      <!-- PRODUCTS -->
      <div v-if="formType == 'p'">
        <h6 class="heading-small text-muted mb-4">EPAY Product</h6>
        <div class="row">
          <base-input label="EPAY CATEGORY" class="col-md-6">
            <a-input type="text" v-model="epayCategory.name" disabled />
          </base-input>

          <base-input label="EPAY GROUP" class="col-md-6">
            <a-input type="text" v-model="epayGroup.name" disabled />
          </base-input>

          <base-input
            label="Barcode Search"
            v-if="formMode == 'a'"
            class="col-md-12"
          >
            <a-input
              type="text"
              v-model="barcodeSearch"
              @keyup.enter="searchProduct"
            />
            <small
              ><span class="fa fa-info-circle" /> Search the barcode of the
              product you wish to add on the selected EPAY group</small
            >
          </base-input>

          <base-input label="Barcode" v-else class="col-md-12">
            <a-input type="text" v-model="epayProduct.epay_barcode" disabled />
          </base-input>
        </div>

        <hr class="my-3" />

        <div v-if="!_.isEmpty(epayProduct)" class="row">
          <div class="col-md-8">
            <div class="row">
              <base-input label="Name/Description" class="col-md-12">
                <a-input type="text" v-model="epayProduct.name" />
              </base-input>
              <base-input label="Code" class="col-md-12" v-if="formMode == 'a'">
                <a-input type="text" v-model="epayProduct.stock_no" />
              </base-input>
              <base-input label="Code" class="col-md-12" v-else>
                <a-input type="text" v-model="epayProduct.epay_refcode" />
              </base-input>
              <base-input label="EPAY Type" class="col-md-12">
                <a-select
                  style="width: 100%"
                  placeholder="Please select"
                  optionFilterProp="children"
                  v-model="epayProduct.epay_type_id"
                >
                  <a-select-option
                    v-for="epayType in epayTypes"
                    :key="epayType"
                    :value="epayType.id"
                    >{{ epayType.name }}</a-select-option
                  >
                </a-select>
              </base-input>
              <base-input label="Sequence No" class="col-md-6">
                <a-input type="number" v-model="epayProduct.sequence_id" />
              </base-input>
              <base-input label="Start Date" class="col-md-6">
                <a-date-picker v-model="epayProduct.start_date" />
              </base-input>
              <base-input label="Min Amount" class="col-md-6">
                <a-input type="number" v-model="epayProduct.min_amount" />
              </base-input>
              <base-input label="Max Amount" class="col-md-6">
                <a-input type="number" v-model="epayProduct.max_amount" />
              </base-input>

              <base-input label="Epay Logo" class="col-md-6">
                <a-select
                  @change="logoChange"
                  style="width: 100%"
                  placeholder="Please select"
                  optionFilterProp="children"
                  v-model="epayProduct.epay_logo_id"
                >
                  <a-select-option
                    v-for="logo in epayLogos"
                    :key="logo"
                    :value="logo.id"
                    >{{ logo.name }}</a-select-option
                  >
                </a-select>
              </base-input>
              <base-input label="Epay Guide" class="col-md-6">
                <a-select
                  @change="guideChange"
                  style="width: 100%"
                  placeholder="Please select"
                  optionFilterProp="children"
                  v-model="epayProduct.epay_guide_id"
                >
                  <a-select-option
                    v-for="guide in epayGuides"
                    :key="guide"
                    :value="guide.id"
                    >{{ guide.name }}</a-select-option
                  >
                </a-select>
              </base-input>

              <base-input label="Service Charge Article" class="col-md-12">
                <a-input
                  type="text"
                  v-model="epayProduct.service_charge_article"
                />
                <small
                  ><span class="fa fa-info-circle" /> Search the barcode of the
                  product to be used</small
                >
              </base-input>
            </div>
          </div>
          <div class="col-md-4">
            <base-input label="EPAY Logo">
              <a-upload
                disabled
                listType="picture-card"
                :fileList="fileListLogo"
              >
                <div v-if="fileListLogo.length < 1">
                  +
                  <div class="ant-upload-text"><small>Select logo</small></div>
                </div>
              </a-upload>
            </base-input>
            <br />
            <base-input label="EPAY Guide">
              <a-upload
                disabled
                listType="picture-card"
                :fileList="fileListGuide"
              >
                <div v-if="fileListGuide.length < 1">
                  +
                  <div class="ant-upload-text"><small>Select guide</small></div>
                </div>
              </a-upload>
            </base-input>
            <br />
            <base-input label="Status">
              <a-select v-model="epayProduct.status" style="width: 100%">
                <a-select-option key="A" value="A">Active</a-select-option>
                <a-select-option key="I" value="I">In-Active</a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>

        <div
          class="float-right"
          style="position: absolute; bottom: 20px; right: 20px"
        >
          <button class="btn btn-success" @click.prevent="saveProduct">
            Save
          </button>
          <button class="btn" @click.prevent="onClose">Cancel</button>
        </div>
      </div>
    </a-drawer>
    <!-- END DRAWER -->

    <div class="card mb-3">
      <div class="card shadow" style="min-height: 100%">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <!-- TEMPLATE START -->
            <div
              class="col-md-3 col-sm-3"
              style="
                padding: 0px;
                border-right: 1px #e9ecef solid;
                height: 600px;
              "
            >
              <ul
                class="list-group list-group-flush"
                style="padding-left: 15px"
              >
                <li
                  class="list-group-item"
                  style="
                    font-size: 14px;
                    height: 55px;
                    background-color: #f7f7f7;
                  "
                >
                  <div class="row">
                    <div class="col-md-8">EPAY TEMPLATES</div>
                    <div class="col-md-4 float-right">
                      <base-button
                        class="float-right ml-1"
                        type="primary"
                        size="sm"
                        @click.prevent="showDrawer('t', 'a')"
                        ><span class="fa fa-plus" />
                      </base-button>
                    </div>
                    <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                  </div>
                </li>
                <div style="height: 545px; overflow-y: scroll">
                  <li
                    class="list-group-item"
                    style="font-size: 14px"
                    v-for="epayTemplate in epayTemplates"
                    :key="epayTemplate.id"
                    :class="[{ selected2: epayTemplateId == epayTemplate.id }]"
                  >
                    <div class="row" @click="selectTemplate(epayTemplate)">
                      <div class="col-md-8">
                        <a-dropdown v-if="epayTemplateId == epayTemplate.id">
                          <a class="ant-dropdown-link" href="#">
                            <span class="fa fa-ellipsis-v"></span>
                          </a>
                          <a-menu slot="overlay">
                            <a-menu-item @click="showDrawer('t', 'e')">
                              Edit - {{ epayTemplate.name }}
                            </a-menu-item>
                            <a-menu-item key="2">
                              <a-popconfirm
                                title="You are about to delete this record?"
                                okText="Delete"
                                cancelText="Cancel"
                                @confirm="deleteTemplate()"
                              >
                                Delete - {{ epayTemplate.name }}
                              </a-popconfirm>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                        &nbsp;
                        {{ epayTemplate.name }}
                      </div>
                      <div class="col-md-4">
                        <span
                          class="ni ni-bold-right float-right"
                          style="padding-bottom: 5px"
                        />
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
            <!-- TEMPLATE END -->

            <!-- CATEGORY START -->
            <div
              class="col-md-3 col-sm-3"
              style="
                padding: 0px;
                border-right: 1px #e9ecef solid;
                height: 600px;
              "
            >
              <ul class="list-group list-group-flush">
                <li
                  class="list-group-item"
                  style="
                    font-size: 14px;
                    height: 55px;
                    background-color: #f7f7f7;
                  "
                >
                  <div class="row">
                    <div class="col-md-8">EPAY CATEGORIES</div>
                    <div class="col-md-4 float-right">
                      <base-button
                        :disabled="epayTemplateId == null"
                        class="float-right ml-1"
                        type="primary"
                        size="sm"
                        @click.prevent="showDrawer('c', 'a')"
                        ><span class="fa fa-plus" />
                      </base-button>
                    </div>
                    <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                  </div>
                </li>
                <div style="height: 545px; overflow-y: scroll">
                  <li
                    class="list-group-item"
                    style="font-size: 14px"
                    v-for="epayCategory in epayCategories"
                    :key="epayCategory.id"
                    :class="[{ selected2: epayCategoryId == epayCategory.id }]"
                  >
                    <div class="row" @click="selectCategory(epayCategory)">
                      <div class="col-md-8">
                        <a-dropdown v-if="epayCategoryId == epayCategory.id">
                          <a class="ant-dropdown-link" href="#">
                            <span class="fa fa-ellipsis-v"></span>
                          </a>
                          <a-menu slot="overlay">
                            <a-menu-item @click="showDrawer('c', 'e')">
                              Edit - {{ epayCategory.name }}
                            </a-menu-item>
                            <a-menu-item key="2">
                              <a-popconfirm
                                title="You are about to delete this record?"
                                okText="Delete"
                                cancelText="Cancel"
                                @confirm="deleteCategory()"
                              >
                                Delete - {{ epayCategory.name }}
                              </a-popconfirm>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                        &nbsp;
                        {{ epayCategory.name }}
                      </div>
                      <div class="col-md-4">
                        <span
                          class="ni ni-bold-right float-right"
                          style="padding-bottom: 5px"
                        />
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
            <!-- CATEGORY END -->

            <!-- GROUP START -->
            <div
              class="col-md-3 col-sm-3"
              style="
                padding: 0px;
                border-right: 1px #e9ecef solid;
                height: 600px;
              "
            >
              <ul class="list-group list-group-flush">
                <li
                  class="list-group-item"
                  style="
                    font-size: 14px;
                    height: 55px;
                    background-color: #f7f7f7;
                  "
                >
                  <div class="row">
                    <div class="col-md-8">EPAY GROUPS</div>
                    <div class="col-md-4 float-right">
                      <base-button
                        :disabled="epayCategoryId == null"
                        class="float-right ml-1"
                        type="primary"
                        size="sm"
                        @click.prevent="showDrawer('g', 'a')"
                        ><span class="fa fa-plus" />
                      </base-button>
                    </div>
                    <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                  </div>
                </li>
                <div style="height: 545px; overflow-y: scroll">
                  <li
                    class="list-group-item"
                    style="font-size: 14px"
                    v-for="epayGroup in epayGroups"
                    :key="epayGroup.id"
                    :class="[{ selected2: epayGroupId == epayGroup.id }]"
                  >
                    <div class="row" @click="selectGroup(epayGroup)">
                      <div class="col-md-8">
                        <a-dropdown v-if="epayGroupId == epayGroup.id">
                          <a class="ant-dropdown-link" href="#">
                            <span class="fa fa-ellipsis-v"></span>
                          </a>
                          <a-menu slot="overlay">
                            <a-menu-item @click="showDrawer('g', 'e')">
                              Edit - {{ epayGroup.name }}
                            </a-menu-item>
                            <a-menu-item key="2">
                              <a-popconfirm
                                title="You are about to delete this record?"
                                okText="Delete"
                                cancelText="Cancel"
                                @confirm="deleteGroup()"
                              >
                                Delete - {{ epayGroup.name }}
                              </a-popconfirm>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                        &nbsp;
                        {{ epayGroup.name }}
                      </div>
                      <div class="col-md-4">
                        <span
                          class="ni ni-bold-right float-right"
                          style="padding-bottom: 5px"
                        />
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
            <!-- GROUP END -->

            <!-- PRODUCT START -->
            <div class="col-md-3 col-sm-3" style="padding: 0px; height: 600px">
              <ul class="list-group list-group-flush">
                <li
                  class="list-group-item"
                  style="
                    font-size: 14px;
                    height: 55px;
                    background-color: #f7f7f7;
                  "
                >
                  <div class="row">
                    <div class="col-md-8">EPAY PRODUCTS</div>
                    <div class="col-md-4 float-right">
                      <base-button
                        :disabled="epayGroupId == null"
                        class="float-right ml-1"
                        type="primary"
                        size="sm"
                        @click.prevent="showDrawer('p', 'a')"
                        ><span class="fa fa-plus" />
                      </base-button>
                    </div>
                    <!-- <div v-if="accessRights.includes('A')" class="col-md-4 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click.prevent="showDrawer('addCategory', 'division', null)"><span class="fa fa-plus"/> </base-button></div> -->
                  </div>
                </li>
                <div style="height: 545px; overflow-y: scroll">
                  <li
                    class="list-group-item"
                    style="font-size: 14px"
                    v-for="epayProduct in epayProducts"
                    :key="epayProduct.id"
                    :class="[{ selected2: epayProductId == epayProduct.id }]"
                  >
                    <div class="row" @click="selectProduct(epayProduct)">
                      <div class="col-md-8">
                        <a-dropdown v-if="epayProductId == epayProduct.id">
                          <a class="ant-dropdown-link" href="#">
                            <span class="fa fa-ellipsis-v"></span>
                          </a>
                          <a-menu slot="overlay">
                            <a-menu-item @click="showDrawer('p', 'e')">
                              Edit - {{ epayProduct.name }}
                            </a-menu-item>
                            <a-menu-item key="2">
                              <a-popconfirm
                                title="You are about to delete this record?"
                                okText="Delete"
                                cancelText="Cancel"
                                @confirm="deleteProduct()"
                              >
                                Delete - {{ epayProduct.name }}
                              </a-popconfirm>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                        &nbsp;
                        {{ epayProduct.name }}
                      </div>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
            <!-- PRODUCT END -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import HTTPRequest from "../../controllers/httpRequest.js";
export default {
  data: function () {
    return {
      // Templates
      epayTemplates: [],
      epayTemplate: {},
      epayTemplateId: null,

      // Categories
      epayCategories: [],
      epayCategory: {},
      epayCategoryId: null,

      // Groups
      epayGroups: [],
      epayGroup: {},
      epayGroupId: null,

      // Products
      epayProducts: [],
      epayProduct: {},
      epayProductId: null,

      // Other EPAY Profiles
      epayTypes: [],
      epayLogos: [],
      epayGuides: [],
      fileListLogo: [],
      fileListGuide: [],

      // Drawer
      drawerVisible: false,
      formType: "t",
      formMode: "a",

      // Search
      barcodeSearch: null,
    };
  },
  mounted: async function () {
    this.getEpayTemplates();
  },
  computed: {
    ...mapState(["endPoint", "publicUrl"]),
  },
  methods: {
    async showDrawer(type, mode) {
      this.formType = type;
      this.formMode = mode;
      this.drawerVisible = true;
      if (mode == "a" && type == "t") {
        this.epayTemplate = {};
        this.epayTemplateId = null;
        this.epayCategory = {};
        this.epayCategoryId = null;
        this.epayGroup = {};
        this.epayGroupId = null;
        this.epayProduct = {};
        this.epayProductId = null;
      }
      if (mode == "a" && type == "c") {
        this.epayCategory = {};
        this.epayCategoryId = null;
        this.epayGroup = {};
        this.epayGroupId = null;
        this.epayProduct = {};
        this.epayProductId = null;
      }
      if (mode == "a" && type == "g") {
        this.epayGroup = {};
        this.epayGroupId = null;
        this.epayProduct = {};
        this.epayProductId = null;
      }
      if (mode == "a" && type == "p") {
        this.epayProduct = {};
        this.epayProductId = null;
      }

      if (type == "p") {
        var options = await HTTPRequest.getRequest(
          this.endPoint + "epay_logos",
          null
        );
        this.epayLogos = options.data;
        options = await HTTPRequest.getRequest(
          this.endPoint + "epay_guides",
          null
        );
        this.epayGuides = options.data;
        options = await HTTPRequest.getRequest(
          this.endPoint + "epay_types",
          null
        );
        this.epayTypes = options.data;
      }
    },
    onClose() {
      this.drawerVisible = false;
    },
    // TEMPLATES
    async getEpayTemplates() {
      var options = await HTTPRequest.getRequest(
        this.endPoint + "epay_templates",
        null
      );
      this.epayTemplates = options;
    },
    async saveTemplate() {
      var templateData = {
        epay_template: {
          name: this.epayTemplate.name,
          code: this.epayTemplate.code,
        },
      };
      if (this.formMode == "a") {
        var options = await HTTPRequest.postRequest(
          this.endPoint + "epay_templates",
          null,
          templateData
        );
      } else {
        var options = await HTTPRequest.putRequest(
          this.endPoint + "epay_templates/" + this.epayTemplateId,
          null,
          templateData
        );
      }
      if (options.error == undefined) {
        this.$message["success"]("EPAY Template operation was successful");
        this.onClose();
        this.getEpayTemplates();
      } else {
        this.$message["error"](
          "EPAY Template operation failed - " + options.error
        );
      }
    },
    async selectTemplate(selectedTemplate) {
      this.epayTemplate = Object.assign({}, selectedTemplate);
      this.epayTemplateId = selectedTemplate.id;
      this.epayCategory = {};
      this.epayCategoryId = null;
      this.epayGroup = {};
      this.epayGroupId = null;
      this.epayProduct = {};
      this.epayProductId = null;
      var options = await HTTPRequest.getRequest(
        this.endPoint +
          "epay_categories?epay_template_id=" +
          this.epayTemplateId,
        null
      );
      this.epayCategories = options;
      this.epayGroups = [];
      this.epayProducts = [];
    },
    async deleteTemplate() {
      var templateData = { epay_template: { status: "D" } };
      var options = await HTTPRequest.putRequest(
        this.endPoint + "epay_templates/" + this.epayTemplateId,
        null,
        templateData
      );
      this.onClose();
      this.getEpayTemplates();
    },

    // CATEGORIES
    async getEpayCategories() {
      var options = await HTTPRequest.getRequest(
        this.endPoint + "epay_categories",
        null
      );
      this.epayCategories = options;
    },
    async saveCategory() {
      var categoryData = {
        epay_category: {
          name: this.epayCategory.name,
          sequence_id: this.epayCategory.sequence_id,
          epay_template_id: this.epayTemplateId,
        },
      };
      if (this.formMode == "a") {
        var options = await HTTPRequest.postRequest(
          this.endPoint + "epay_categories",
          null,
          categoryData
        );
      } else {
        var options = await HTTPRequest.putRequest(
          this.endPoint + "epay_categories/" + this.epayCategoryId,
          null,
          categoryData
        );
      }
      if (options.error == undefined) {
        this.$message["success"]("EPAY Category operation was successful");
        this.onClose();
        this.selectTemplate(this.epayTemplate);
      } else {
        this.$message["error"](
          "EPAY Category operation failed - " + options.error
        );
      }
    },
    async selectCategory(selectCategory) {
      this.epayCategory = Object.assign({}, selectCategory);
      this.epayCategoryId = selectCategory.id;
      this.epayGroup = {};
      this.epayGroupId = null;
      this.epayProduct = {};
      this.epayProductId = null;
      var options = await HTTPRequest.getRequest(
        this.endPoint + "epay_groups?epay_category_id=" + this.epayCategoryId,
        null
      );
      this.epayGroups = options;
      this.epayProducts = [];
    },
    async deleteCategory() {
      var categoryData = { epay_category: { status: "D" } };
      var options = await HTTPRequest.putRequest(
        this.endPoint + "epay_categories/" + this.epayCategoryId,
        null,
        categoryData
      );
      this.onClose();
      this.selectTemplate(this.epayTemplate);
    },

    // GROUPS
    async saveGroup() {
      var groupData = {
        epay_group: {
          name: this.epayGroup.name,
          code: this.epayGroup.code,
          sequence_id: this.epayGroup.sequence_id,
          epay_category_id: this.epayCategoryId,
        },
      };
      if (this.formMode == "a") {
        var options = await HTTPRequest.postRequest(
          this.endPoint + "epay_groups",
          null,
          groupData
        );
      } else {
        var options = await HTTPRequest.putRequest(
          this.endPoint + "epay_groups/" + this.epayGroupId,
          null,
          groupData
        );
      }
      if (options.error == undefined) {
        this.$message["success"]("EPAY Group operation was successful");
        this.onClose();
        this.selectCategory(this.epayCategory);
      } else {
        this.$message["error"](
          "EPAY Group operation failed - " + options.error
        );
      }
    },
    async selectGroup(selectGroup) {
      this.epayGroup = Object.assign({}, selectGroup);
      this.epayGroupId = selectGroup.id;
      this.epayProduct = {};
      this.epayProductId = null;
      var options = await HTTPRequest.getRequest(
        this.endPoint + "epay_products?epay_group_id=" + this.epayGroupId,
        null
      );
      this.epayProducts = options.data;
    },
    async deleteGroup() {
      var groupData = { epay_group: { status: "D" } };
      var options = await HTTPRequest.putRequest(
        this.endPoint + "epay_groups/" + this.epayGroupId,
        null,
        groupData
      );
      this.onClose();
      this.selectCategory(this.epayCategory);
    },

    // PRODUCTS
    async searchProduct() {
      var product = await HTTPRequest.getRequest(
        this.endPoint + "products?barcode=" + this.barcodeSearch,
        null
      );
      if (product.data.length > 0) {
        this.epayProduct = product.data[0];
        // if(!_.isEmpty(this.rteProduct.filename)){
        //     this.fileList = [{
        //         uid: this.rteProduct.id,
        //         name: this.rteProduct.filename,
        //         status: 'done',
        //         url: this.publicUrl + 'product_images/' + this.rteProduct.filename,
        //     }]
        // }
      } else {
        this.$message["error"](
          "Product not found. Please search another barcode."
        );
        this.epayProduct = {};
      }
    },
    async saveProduct() {
      var productData = Object.assign({}, this.epayProduct);
      productData.epay_group_id = this.epayGroupId;
      productData.epay_category_id = this.epayCategoryId;

      if (this.formMode == "a") {
        productData.epay_barcode = this.barcodeSearch;
        productData.epay_refcode = productData.stock_no;
        var options = await HTTPRequest.postRequest(
          this.endPoint + "epay_products",
          null,
          productData
        );
      } else {
        var options = await HTTPRequest.putRequest(
          this.endPoint + "epay_products/" + this.epayProductId,
          null,
          productData
        );
      }
      if (options.error == undefined) {
        this.$message["success"]("EPAY Product operation was successful");
        this.onClose();
        this.selectGroup(this.epayGroup);
      } else {
        this.$message["error"](
          "EPAY Product operation failed - " + options.error
        );
      }
    },
    async selectProduct(selectProduct) {
      this.epayProduct = Object.assign({}, selectProduct);
      this.epayProductId = selectProduct.id;
      var logo = await HTTPRequest.getRequest(
        this.endPoint + "epay_logos/" + this.epayProduct.epay_logo_id,
        null
      );
      var guide = await HTTPRequest.getRequest(
        this.endPoint + "epay_guides/" + this.epayProduct.epay_guide_id,
        null
      );
      if (!_.isEmpty(logo)) {
        this.fileListLogo = [
          {
            uid: logo.id,
            name: logo.name,
            status: "done",
            url: this.publicUrl + "epay_logos_images/" + logo.filename,
          },
        ];
      }
      if (!_.isEmpty(guide)) {
        this.fileListGuide = [
          {
            uid: guide.id,
            name: guide.name,
            status: "done",
            url: this.publicUrl + "epay_guides_images/" + guide.filename,
          },
        ];
      }
    },
    async deleteProduct() {
      var productData = { epay_product: { status: "D" } };
      var options = await HTTPRequest.putRequest(
        this.endPoint + "epay_products/" + this.epayProductId,
        null,
        productData
      );
      this.onClose();
      this.selectGroup(this.epayGroup);
    },

    // LOGOS & GUIDES
    logoChange(value, options) {
      var epayLogo = options.data.key;
      if (!_.isEmpty(epayLogo)) {
        this.fileListLogo = [
          {
            uid: epayLogo.id,
            name: epayLogo.name,
            status: "done",
            url: this.publicUrl + "epay_logos_images/" + epayLogo.filename,
          },
        ];
      }
    },
    guideChange(value, options) {
      var epayGuide = options.data.key;
      if (!_.isEmpty(epayGuide)) {
        this.fileListGuide = [
          {
            uid: epayGuide.id,
            name: epayGuide.name,
            status: "done",
            url: this.publicUrl + "epay_guides_images/" + epayGuide.filename,
          },
        ];
      }
    },
  },
};
</script>

<style>
.selected2 {
  background-color: #eff6ff;
  color: #2371cc;
}
</style>